export enum UserGenderEnum {
    MALE = 'MALE',
    FEMALE = 'FEMALE'
}

